export default "__VITE_ASSET__BH3MU6Pf__"